/**
 * Increments one component of a "X.Y[.Z...]" version string, zeroing all
 * components to the right. Returns '0.1' for malformed input.
 */
const bumpVersionComponent = (versionId: string, component: number): string => {
  const parts = versionId.split('.').map((n) => parseInt(n, 10));
  if (!parts.length || parts.some((n) => !Number.isFinite(n))) return '0.1';
  parts[component] += 1;
  for (let i = component + 1; i < parts.length; i++) parts[i] = 0;
  return parts.join('.');
};

export default bumpVersionComponent;
